/* Dosya adından kare kimliği.

   Ayrı bir dosyada, çünkü saf: DOM'a da API'ye de dokunmuyor, yani `node:test`
   altında ağsız sürülebiliyor. Panelin geri kalanı tarayıcıya bağlı ve ancak
   elle doğrulanıyor; bu kural ise sessizce bozulabilecek cinsten.

   **Alfabe sunucununkiyle aynı olmak zorunda.** Kimlik R2 anahtarının içine
   giriyor (`browse/<id>.webp`) ve sunucu `photoId` şemasıyla küçük harf,
   rakam ve tireden başkasını kabul etmiyor. Burada üretilen bir kimlik o
   şemadan geçmezse yükleme 400 alır — ve hata, sebebinden (dosya adındaki
   Türkçe harf) çok uzakta görünür. */

/** Türkçe harfler kimlikte yer alamaz; sunucunun alfabesi onları tanımıyor. */
const TR_FOLD: Record<string, string> = {
  ç: 'c',
  ğ: 'g',
  ı: 'i',
  ö: 'o',
  ş: 's',
  ü: 'u',
  â: 'a',
  î: 'i',
  û: 'u'
};

/** `photos.id` sütunu `varchar(64)`; ek sayaç için pay bırakılıyor. */
const MAX_SEED = 56;

/**
 * `IMG_0042.CR3` → `img-0042`.
 *
 * `taken` yığın içinde verilmiş kimlikleri tutar: aynı adı taşıyan iki dosya
 * (ayrı klasörlerden) aynı kimliği almasın. Asıl tekrar denetimi bu değil —
 * o, sağlama toplamı üzerinden sunucuda yapılıyor (§5.2 dedupe). Buradaki
 * tek iş kimliğin benzersizliği.
 */
export function photoIdFrom(fileName: string, taken: Set<string> = new Set()): string {
  const seed =
    fileName
      .replace(/\.[^.]+$/, '')
      .toLowerCase()
      .replace(/[çğıöşüâîû]/g, (ch) => TR_FOLD[ch] ?? ch)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, MAX_SEED) || 'kare';

  let id = seed;
  let n = 2;
  while (taken.has(id)) id = `${seed}-${n++}`.slice(0, 64);
  taken.add(id);
  return id;
}

/** Orijinalin uzantısı; sunucunun kapalı kümesine düşmeyen her şey `jpg`. */
export const ORIGINAL_EXTS = ['jpg', 'jpeg', 'png', 'webp', 'avif'] as const;

export function originalExtFrom(fileName: string): (typeof ORIGINAL_EXTS)[number] {
  const ext = (fileName.split('.').pop() ?? '').toLowerCase();
  return (ORIGINAL_EXTS as readonly string[]).includes(ext)
    ? (ext as (typeof ORIGINAL_EXTS)[number])
    : 'jpg';
}
